import { getYear } from 'date-fns';

import client from './client';

const gouvApiBaseUrl = 'https://calendrier.api.gouv.fr';
const axiosConfig = { baseURL: gouvApiBaseUrl };

/**
 * Get french holidays for the next 3 years
 * @returns {Promise<AxiosResponse<any>>}
 */
const getHolidays = async () => {
  const currentYear = getYear(new Date());
  const yearN1 = currentYear + 1;
  const yearN2 = currentYear + 2;
  const yearN3 = currentYear + 3;

  const { data: currentYearHolidays } = await client.get(`/jours-feries/metropole/${currentYear}.json`, axiosConfig);
  const { data: yearN1Holidays } = await client.get(`/jours-feries/metropole/${yearN1}.json`, axiosConfig);
  const { data: yearN2Holidays } = await client.get(`/jours-feries/metropole/${yearN2}.json`, axiosConfig);
  const { data: yearN3Holidays } = await client.get(`/jours-feries/metropole/${yearN3}.json`, axiosConfig);

  return {
    ...(currentYearHolidays || {}),
    ...(yearN1Holidays || {}),
    ...(yearN2Holidays || {}),
    ...(yearN3Holidays || {}),
  };
};

const holidaysService = {
  getHolidays,
};

export default holidaysService;
